import React from "react";
import {ILeague} from "modules/types";
import {getLeagueById, getUser, getRoundById} from "modules/selectors";
import styled from "styled-components";
import {useSelector} from "react-redux";
import {MyLeagueNavigationButtons} from "./MyLeagueNavigationButtons";
import {MyLeagueTeamList} from "./MyLeagueTeamsList";
import {media} from "assets/media";

const Wrapper = styled.div`
	box-sizing: border-box;
	border: 1px solid #dddddd;
	border-radius: 4px;
	padding: 20px 32px;
	width: 100%;

	@media screen and ${media.lessThanMD} {
		padding: 12px 14px;
	}
`;

const LeagueName = styled.h3`
	color: ${({theme}) => theme.text_color};
	font-size: 24px;
	font-weight: bold;
	letter-spacing: 0;
	line-height: 29px;
	margin: 0;

	@media screen and ${media.lessThanMD} {
		font-size: 20px;
	}
`;

const Heading = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media screen and ${media.lessThanMD} {
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
	}
`;

const LeagueInfo = styled.p`
	color: #a3a3a3;
	font-size: 14px;
	letter-spacing: 0;
	line-height: 26px;
	text-transform: capitalize;
	font-weight: 300;
	margin: 0;
`;

interface IProps {
	leagueId: ILeague["id"];
}

export const MyLeagueItem: React.FC<IProps> = ({leagueId}) => {
	const league = useSelector(getLeagueById)(leagueId);
	const user = useSelector(getUser);
	const startRound = useSelector(getRoundById)(league?.start_round || 0);

	const isOwner = user?.id === league?.user_id;

	if (!league) {
		return null;
	}

	return (
		<Wrapper className="league-item">
			<Heading>
				<LeagueName>{league.name}</LeagueName>
			</Heading>
			<MyLeagueTeamList />
			<MyLeagueNavigationButtons leagueId={league.id} isOwner={isOwner} />
			<LeagueInfo>
				{league.privacy} league, starting game week {startRound?.number}
			</LeagueInfo>
		</Wrapper>
	);
};
